<template>
	<div class="category">
		<table class="simple-table category__table category__insert">
			<tr>
				<th>신규 카테고리 등록하기</th>
			</tr>
			<tr>
				<td>
					<InputWithButton
						v-model="newCategoryTitle"
						placeholder="카테고리명"
						button-text="등록"
						@click="addCategory"
					/>
				</td>
			</tr>
		</table>
		<div class="category__list-top">
			<div class="category__list-top__status">
				등록: {{ total }}건 / 활성: {{ activated }} / 비활성:
				{{ inactivated }}<br />
				*대표카테고리는 배경입니다.
			</div>
			<div class="category__list-top-right">
				<button
					v-text="'대표카테고리설정'"
					@click="openMainCateSetModal"
					class="btn-main blue"
				/>
				<SelectBoxV2
					v-model="sort"
					:options="sortList"
					@input="onSortChange"
					class="category__list-top__sort"
				/>
			</div>
		</div>
		<table class="table-main cate-table">
			<thead>
				<tr>
					<th
						v-for="(th, idx) in thList"
						:key="idx"
						v-text="th"
						:class="`cate-table__th-${idx}`"
					/>
				</tr>
			</thead>
			<Draggable
				v-model="cateList"
				tag="tbody"
				handle=".cate-table__handle"
				@end="modifyOrder"
			>
				<tr
					v-for="(cate, idx) in cateList"
					:key="cate.idPouchCategory"
					:index="idx"
					:disabled="sort !== 5"
					:class="{ 'cate-table__tr--main': cate.isMainCategory }"
				>
					<td class="cate-table__th-0">
						<span
							class="cate-table__handle"
							:class="{
								'cate-table__handle--disabled': sort !== 5,
							}"
						/>
					</td>
					<td
						v-text="cate.mainCategoryOrder || '-'"
						class="cate-table__th-1"
					/>
					<td>
						<div class="cate-table__text-modifier">
							<div class="cate-table__text-modifier-left">
								<input
									v-model="cate.pouchCategoryText"
									type="text"
									placeholder="카테고리명"
								/>
								<input
									v-model="cate.mainTitle"
									class="cate-table__title"
									type="text"
									placeholder="메뉴타이틀"
								/>
							</div>
							<button
								v-text="'수정하기'"
								class="btn blue cate-table__modify-btn"
								@click="modifyText(cate)"
							/>
						</div>
					</td>
					<td
						v-text="currency(String(cate.pouchCount))"
						class="cate-table__th-3"
					/>
					<td class="cate-table__th-4">
						<button
							:class="`btn ${cate.isDisplay ? 'blue' : 'orange'}`"
							@click="modifyDisplay(cate)"
							v-text="cate.isDisplay ? '전시중' : '비전시'"
						/>
					</td>
				</tr>
			</Draggable>
		</table>
	</div>
</template>
<script>
	import cloneDeep from 'lodash/cloneDeep';
	import isEqual from 'lodash/isEqual';
	import orderBy from 'lodash/orderBy';
	import find from 'lodash/find';
	import util from '@/util';
	import { setJosa } from '@/util';
	import Draggable from 'vuedraggable';
	import InputWithButton from '@/components/InputWithButton';
	import SelectBoxV2 from '@/components/SelectBoxV2';
	import Selector from '@/components/Selector';

	export default {
		name: 'EditorPickCategory',
		components: {
			InputWithButton,
			Draggable,
			SelectBoxV2,
			Selector,
		},
		data() {
			return {
				newCategoryTitle: '',
				sort: 5,
				cateList: [],
				cateListOrigin: [],
				total: 0,
				activated: 0,
				inactivated: 0,
				sortList: [
					{ label: '최신등록순', value: 1 },
					{ label: '이전등록순', value: 2 },
					{ label: '전시순', value: 3 },
					{ label: '비전시순', value: 4 },
					{ label: '정렬순', value: 5 },
					{ label: '정렬역순', value: 6 },
				],
				thList: [
					'노출순서',
					'대표카테고리순서',
					'카테고리명 / 메뉴타이틀',
					'캐스트수',
					'전시설정',
				],
				currency: util.currency,
			};
		},
		mounted() {
			this.getCate();
		},
		computed: {
			hasChanged() {
				return !isEqual(this.cateList, this.cateListOrigin);
			},
		},
		methods: {
			checkHasChange() {
				return !(
					this.hasChanged &&
					!confirm(
						'저장되지 않는 변경 사항이 있습니다.\n계속 하시겠습니까?'
					)
				);
			},
			async getCate() {
				try {
					const { data } = await this.$axiosNoah.get(
						'/pouch/category',
						{
							params: {
								sort: this.sort,
								offset: 0,
								limit: 999,
							},
						}
					);

					this.cateList = data.pouchCategoryList;
					this.total = data.contentTotal;
					this.activated = this.cateList.filter(
						category => category.isDisplay
					).length;
					this.inactivated = this.total - this.activated;
					this.cateListOrigin = cloneDeep(this.cateList);
				} catch (err) {
					console.error(err);
					alert('카테고리 목록을 불러오지 못했습니다.');
				}
			},
			async addCategory() {
				try {
					if (
						!confirm(
							`새로운 카테고리 ${setJosa(this.newCategoryTitle, '을를')} 등록하시겠습니까?`
						)
					)
						return;

					await this.$axiosNoah.post('/pouch/category', {
						isDisplay: false,
						pouchCategoryText: this.newCategoryTitle,
						mainTitle: this.newCategoryTitle,
						sortKey:
							orderBy(this.cateList, ['sortKey'], ['desc'])[0]
								.sortKey + 1,
					});

					this.newCategoryTitle = '';
					this.getCate();
					alert('등록되었습니다.');
				} catch (err) {
					console.error(err);
					alert('등록 실패했습니다.');
				}
			},
			openMainCateSetModal() {
				this.$store.commit('modal/toggleModal', { id: 'MainCateSet' });
			},
			onSortChange() {
				if (this.checkHasChange()) {
					this.getCate();
				} else {
					this.sort = 5;
				}
			},
			modifyCate(id, params) {
				return this.$axiosNoah
					.put(`/pouch/category/${id}`, params)
					.then(() => {
						this.getCate();
					})
					.catch(err => {
						console.error(err);
					});
			},
			async modifyOrder() {
				await this.$nextTick();

				this.cateList
					.map((cate, idx) => ({ ...cate, sortKey: idx + 1 }))
					.filter(
						cate =>
							cate.sortKey !==
							find(this.cateListOrigin, {
								idPouchCategory: cate.idPouchCategory,
							}).sortKey
					)
					.forEach(async category => {
						await this.modifyCate(
							category.idPouchCategory,
							category
						);
					});
			},
			async modifyText(data) {
				try {
					const pouchCategoryText = data.pouchCategoryText.trim();
					const mainTitle = data.mainTitle
						? data.mainTitle.trim()
						: pouchCategoryText;
					const msg = `카테고리명을 "${pouchCategoryText}"로\n메뉴타이틀을 "${mainTitle}"로 변경하시겠습니까?`;

					if (!confirm(msg)) return;

					await this.modifyCate(data.idPouchCategory, {
						...data,
						pouchCategoryText,
						mainTitle,
					});

					alert('수정 되었습니다.');
				} catch (err) {
					console.error(err);
					alert('수정 실패했습니다.');
				}
			},
			async modifyDisplay(data) {
				try {
					const isDisplay = !data.isDisplay;
					const msg =
						setJosa(data.pouchCategoryText, '을를') + !isDisplay
							? ' 전시에서 비전시로 변경하시겠습니까?'
							: ' 비전시에서 전시로 변경하시겠습니까?';

					if (!confirm(msg)) return;

					await this.modifyCate(data.idPouchCategory, {
						...data,
						isDisplay,
					});

					alert('수정 되었습니다.');
				} catch (err) {
					console.error(err);
					alert('수정 실패했습니다.');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	$border: #dfe6ee;
	$background: #f4f7fa;

	.category {
		padding-top: 2em;
	}

	.category__list-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 2em 0;
	}

	.category__list-top__status {
		font-size: 1rem;
		font-weight: bold;
	}

	.category__list-top__sort {
		z-index: 999;
	}

	.category__list-top-right {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.cate-table {
		table-layout: fixed;

		&__th-0 {
			width: 80px;
			padding: 0;
			white-space: nowrap;
		}

		&__th-1 {
			width: 120px;
			padding: 0;
			white-space: nowrap;
			font-weight: 700;
		}

		&__th-3 {
			width: 90px;
			padding: 0;
			white-space: nowrap;
		}

		&__th-4 {
			width: 100px;
			padding: 0;
			white-space: nowrap;
		}

		&__tr--main {
			background: rgba($btn-blue, 0.4);

			&:hover {
				background: rgba($btn-blue, 0.4);
			}
		}

		&__handle {
			position: relative;
			display: block;
			width: 36px;
			height: 36px;
			margin: 0 auto;
			background: $btn-blue;
			cursor: move;
			border-radius: 4px;

			&:after {
				content: '';
				display: block;
				position: absolute;
				width: 1em;
				height: 1px;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: $border;
				box-shadow:
					0 4px 0 0 $border,
					0 -4px 0 0 $border;
			}
		}

		&__handle--disabled {
			cursor: not-allowed;
			background: $red;
		}

		&__text-modifier {
			display: flex;
			align-items: center;
		}

		&__text-modifier-left {
			width: 100%;
		}

		&__title {
			margin-top: 12px;
		}

		&__modify-btn {
			flex-shrink: 0;
			margin-left: 12px;
		}
	}

	.item__is-display--not {
		background: #ffa500;
	}
</style>
